import { IconProp } from '@fortawesome/fontawesome-svg-core'
import { faFileSignature } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { DataTable, DataTableColumn, DataTableOptions, DataType } from '@globaleris/ui.library'
import { CardProps } from '@material-ui/core'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router'
import { AnnexedLeadModel } from '../../../../../../../api/Argentia/endpoints/leads/model/leads'
import { AnnexedParameters } from '../../../../../../../api/Argentia/enums'
import { CardActionProps } from '../../../../../../../components/shared/cardActions/cardActions'
import { StandardCard } from '../../../../../../../components/shared/standardCard/standardCard'
import { enumToSelectOptionArray } from '../../../../../../../helpers'
import { getCustomerDomain } from '../../../../../../../redux'

interface AnnexedLeadCardProps extends CardProps {
  tableData: AnnexedLeadModel[] | undefined
  isLoading: boolean
  footerActions: CardActionProps[]
}

export const AnnexedLeadCard: React.FC<AnnexedLeadCardProps> = ({
  tableData,
  isLoading,
  footerActions,
  ...props
}) => {
  const [t] = useTranslation(['globalerisLibrary', 'leads', 'enums'])
  const history = useHistory()

  const noData = tableData && tableData.length === 0
  // #region Handlers Starts
  // #endregion Handlers Ends

  // #region Functions Starts
  // #endregion Functions Ends

  // #region Form Definition Starts
  // #endregion Form Definition Ends

  // #region DataTable Config Starts
  const annexedParamsTableOptions: DataTableOptions = {
    i18n: t('globalerisLibrary:dataTable', { returnObjects: true }),
    elevation: 0,
    download: false,
    canInsert: false,
    customInsertEditModal: false,
    analytics: {
      customer: getCustomerDomain(),
      view: t('leads:components.leadFile.annexedLeadCard.dataTable.analytics')
    }
  }

  const annexedParamsColumns: DataTableColumn[] = [
    {
      name: 'leadId',
      display: false
    },
    {
      name: 'annexedLeadId',
      display: false
    },
    {
      name: 'annexedParam',
      label: t('leads:components.leadFile.annexedLeadCard.dataTable.columns.annexedParam'),
      type: DataType.SELECT,
      selectOptions: enumToSelectOptionArray(AnnexedParameters, 'enums:AnnexedParameters')
    },
    {
      name: 'value',
      label: t('leads:components.leadFile.annexedLeadCard.dataTable.columns.value'),
      type: DataType.TEXT
    }
  ]
  // #endregion DataTable Config Ends

  // #region Hooks Starts
  // #endregion Hooks Ends

  return (
    <StandardCard
      avatarIcon={<FontAwesomeIcon size={'lg'} icon={faFileSignature as IconProp} />}
      title={t('leads:components.leadFile.annexedLeadCard.title')}
      isLoading={isLoading}
      footerActions={footerActions}
      showEmptyContent={noData}
      emptyCaption={t('leads:components.leadFile.annexedLeadCard.emptyCaption')}
      {...props}
    >
      <DataTable
        columns={annexedParamsColumns}
        options={annexedParamsTableOptions}
        data={tableData}
      />
    </StandardCard>
  )
}
